/**
 * This component intentionally left blank.
 */
export function NewPartUserPriceForm() {
  return null;
}
